import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

const AdvertisingSection = styled.section`
  padding: 60px 50px;
  background: linear-gradient(135deg, #1d3557, #457b9d);
  color: white;
  width: 100%;

  @media (max-width: 768px) {
    padding: 40px 20px;
  }
`;

const SlideContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  text-align: center;
  padding: 20px;
`;

const Title = styled.h2`
  font-size: 2.5rem;
  margin-bottom: 20px;
  color: #fff;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

const Description = styled.p`
  font-size: 1.2rem;
  margin-bottom: 30px;
  line-height: 1.6;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
`;

const Button = styled.button`
  background-color: #e63946;
  color: white;
  padding: 12px 30px;
  border: none;
  border-radius: 4px;
  font-size: 1.1rem;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #dc2f3d;
  }
`;

const Advertising = () => {
  const slides = [
    {
      title: "Offre Spéciale Papeterie & Informatique",
      description: "Profitez de -20% sur tous nos produits de papeterie pour toute commande supérieure à 100$.",
      buttonText: "En savoir plus"
    },
    {
      title: "Nouveaux Arrivages",
      description: "Découvrez notre nouvelle gamme de fournitures de bureau écologiques.",
      buttonText: "Voir les produits"
    },
    {
      title: "Pack Entreprise",
      description: "Solutions complètes pour l'équipement de votre bureau à prix avantageux.",
      buttonText: "Voir les offres"
    }
  ];

  return (
    <AdvertisingSection>
      <Swiper
        modules={[Autoplay, Pagination]}
        spaceBetween={30}
        slidesPerView={1}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        pagination={{ clickable: true }}
      >
        {slides.map((slide, index) => (
          <SwiperSlide key={index}>
            <SlideContent>
              <Title>{slide.title}</Title>
              <Description>{slide.description}</Description>
              <Button>{slide.buttonText}</Button>
            </SlideContent>
          </SwiperSlide>
        ))}
      </Swiper>
    </AdvertisingSection>
  );
};

export default Advertising;